<template #default>
    <form
        v-if="status.detail"
        @submit.prevent="locationUUID ? requestUpdate() : requestCreate()"
    >
        <div class="row">
            <div class="col-md-12">
                <h6 class="font-weight-bold text-info">
                    <i class="mdi mdi-map-marker mr-1"></i>
                    Basic Information
                </h6>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('label.name')"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.name"
                        :class="{ 'is-invalid': submitted && !$v.createForm.name.required }"
                        autocomplete="off"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="submitted && !$v.createForm.name.required" class="text-right">
                        {{ $t("message.requiredX", [$t("label.name")]) }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('label.displayName')"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.displayName"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('label.address')"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.addrLine1"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    label=""
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.addrLine2"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>  
            </div>
            <div class="col-md-12">
                <b-form-group
                    label=""
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.addrLine3"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('label.city')"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.city"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('label.postcode')"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.postcode"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('module.state')"
                    label-cols="4"
                    label-align="left"
                >
                    <multiselect
                        v-model="createForm.state"
                        deselect-label="Can't remove this value"
                        track-by="value"
                        label="text"
                        :placeholder="$t('message.pleaseSelectX', [$t('module.state')])"
                        :options="stateDdl"
                        :searchable="true"
                        :allow-empty="false"
                        :append-to-body="true"
                        :class="[submitted && !$v.createForm.state.required ? 'border border-danger' : '']"
                    />
                    <div v-if="submitted && !$v.createForm.state.required" class="invalid-feedback d-block text-right">
                        {{ $t("message.requiredX", [$t("module.state")]) }}
                    </div>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('module.country')"
                    label-cols="4"
                    label-align="left"
                >
                    <multiselect
                        v-model="createForm.country"
                        deselect-label="Can't remove this value"
                        track-by="value"
                        label="text"
                        :placeholder="$t('message.pleaseSelectX', [$t('module.country')])"
                        :options="countryDdl"
                        :searchable="true"
                        :allow-empty="false"
                        :append-to-body="true"
                        :class="[submitted && !$v.createForm.state.required ? 'border border-danger' : '']"
                    />
                    <div v-if="submitted && !$v.createForm.country.required" class="invalid-feedback d-block text-right">
                        {{ $t("message.requiredX", [$t("module.country")]) }}
                    </div>
                </b-form-group>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-12">
                <h6 class="font-weight-bold text-info">
                    <i class="mdi mdi-crosshairs-gps mr-1"></i>
                    Coordinate
                </h6>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('label.latitude')"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.lat"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('label.longitude')"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.lng"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group
                    :label="$t('label.googleMapLink')"
                    label-cols="4"
                    label-align="left"
                >
                    <b-form-input
                        v-model.trim="createForm.googleMapLink"
                        autocomplete="off"
                    ></b-form-input>
                </b-form-group>
            </div>
        </div>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button
                type="button"
                variant="danger"
                class="mr-2 col-2"
                @click="$emit('done')"
            >{{ $t('label.cancel') }}</b-button>
            <b-button
                type="submit"
                variant="info"
                class="col-2"
                :disabled="!status.save"
            >
                <span v-if="status.save">
                    {{ locationUUID ? $t('label.updateX', []) : $t('label.createX', []) }}
                </span>
                <div v-else>
                    <b-spinner small />
                </div>
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center align-items-center m-5 p-5">
        <b-spinner class="m-5" variant="info" role="status"></b-spinner>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { locationMethods, lookupMethods } from "@/state/api";
import { LOCATION_MODULE } from "@/state/api/location.state";

export default {
    props: {
        locationUUID: {
            type: String,
            required: false,
        },
        searchCriteria: {
            type: Object,
            required: false,
        },
    },
    validations() {
        return {
            createForm: {
                country: { required },
                state: { required },
                name: { required },
            },
        };
    },
    components: { Multiselect },
    async created() {
        await this.lookupCountry({});
        await this.lookupState({});
        await this.getLocationData();
    },
    data() {
        return {
            submitted: false,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...locationMethods,
        ...lookupMethods,
        defaultForm() {
            return {
                uuid: "",
                country: null,
                state: null,
                name: "",
                displayName: "",
                addrLine1: "",
                addrLine2: "",
                addrLine3: "",
                city: "",
                postcode: "",
                googleMapLink: "",
                lat: "",
                lng: "",
            };
        },
        async getLocationData() {
            if (this.locationUUID) {
                await this.getLocation({ uuid: this.locationUUID })
                    .then((result) => {
                        if (result?.success) {
                            this.createForm = {
                                uuid: this.data.uuid,
                                name: this.data.name,
                                displayName: this.data.displayName,
                                addrLine1: this.data.addrLine1,
                                addrLine2: this.data.addrLine2,
                                addrLine3: this.data.addrLine3,
                                city: this.data.city,
                                postcode: this.data.postcode,
                                googleMapLink: this.data.googleMapLink,
                                lat: this.data.lat,
                                lng: this.data.lng,
                                country: this.data.country ? {
                                    value: this.data.country.uuid,
                                    text: this.data.country.name
                                } : null,
                                state: this.data.state ? {
                                    value: this.data.state.uuid,
                                    text: this.data.state.name
                                } : null,
                            };
                        }
                    });
            }
        },
        requestCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    countryUUID: this.createForm.country?.value,
                    stateUUID: this.createForm.state?.value,
                };
                this.createLocation({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        requestUpdate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    countryUUID: this.createForm.country.value,
                    stateUUID: this.createForm.state.value,
                };
                this.updateLocation({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
    computed: {
        ...mapState(LOCATION_MODULE, ['status']),
        countryDdl() {
            return this.$store.state.api.lookup.countryDdl || [];
        },
        stateDdl() {
            return this.$store.state.api.lookup.stateDdl || [];
        },
        data() {
            return this.$store.state.api.location.details;
        },
    },
}
</script>
